const PATH = 'fe.components.measure.view.cycles.cycle_scores_form';

const messages = {
  enterScores: {
    key: `${PATH}.enter_scores`,
    defaultValue: 'Enter Scores'
  },
  sectionDescription: {
    key: `${PATH}.section_description`,
    defaultValue: 'Select indicator ranges and dimension scores'
  },
  enterRanges: {
    key: `${PATH}.enter_ranges`,
    defaultValue: 'Enter Ranges'
  },
  enterRangesDescription: {
    key: `${PATH}.enter_ranges_description`,
    defaultValue: 'Select indicator and dimension ranges'
  },
  optional: {
    key: `${PATH}.optional`,
    defaultValue: 'Optional'
  },
  optionalTooltipLine1: {
    key: `${PATH}.optional_tooltip_line1`,
    defaultValue: 'Indicator and dimension ranges are optional.'
  },
  optionalTooltipLine2: {
    key: `${PATH}.optional_tooltip_line2`,
    defaultValue: 'You can submit your observation without selecting them.'
  }
};

export default messages;
